<div
    [style.display]="display"
    [matTooltip]="customMatTooltip"
    [matTooltipDisabled]="customMatTooltipDisabled"
    [matTooltipHideDelay]="customMatTooltipHideDelay"
    [matTooltipPosition]="customMatTooltipPosition"
    [matTooltipPositionAtOrigin]="customMatTooltipPositionAtOrigin"
    [matTooltipShowDelay]="customMatTooltipShowDelay"
    [matTooltipClass]="customTooltipClass"
    [class]="customTooltipStyle">
    <ng-content></ng-content>
</div>
